module.exports = __webpack_public_path__ + "c54e2e7f83639e412a70fab8dacc5993.svg";